import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Translation, TranslocoLoader } from '@jsverse/transloco'
import { Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<Translation> {
    const normalizedLang = lang.toLowerCase()
    const uppercaseLang = normalizedLang.toUpperCase()

    // Keep backward compatibility with existing uppercase translation assets.
    return this.http.get<Translation>(`./assets/i18n/${uppercaseLang}.json`).pipe(
      catchError(() => this.http.get<Translation>(`./assets/i18n/${normalizedLang}.json`))
    )
  }
}
